import { load as loadCompanyContacts } from './CompanyContacts/Components/company-contacts-loader';
import { load as loadCompanyExecutives } from './CompanyProfile/Components/company-executives-loader';
import { load as loadProductDetail } from './Products/Components/product-detail-loader';
import { load as loadSearch } from './Search/Components/search-loader';
import { load as loadServiceLocator } from './ServiceLocator/Components/service-locator-loader';

export function loadComponents() {
  loadCompanyContacts();
  loadCompanyExecutives();
  loadProductDetail();
  loadSearch();
  loadServiceLocator();
}
